/**
 * Enum representing the width options for MatDialog.
 */
export enum MatDialogWidth {
    XXS = 'min(80%, 400px)',
    XS = 'min(80%, 500px)',
    SM = 'min(80%, 640px)',
    MD = 'min(80%, 768px)',
    LG = 'min(80%, 1024px)',
    XL = 'min(80%, 1280px)',
}
